export const filterVehicles = (vehicles = [], searchText = '', statusFilter = 'All') => {
  const normalizedSearch = String(searchText || '').trim().toLowerCase();

  return vehicles.filter((item) => {
    const matchesSearch =
      normalizedSearch.length === 0 ||
      String(item?.registration || '')
        .toLowerCase()
        .includes(normalizedSearch);

    if (!matchesSearch) {
      return false;
    }

    if (statusFilter === 'All') return true;

    const normalizedStatus = String(item?.status || '')
      .trim()
      .toUpperCase()
      .replace(/[\s_-]+/g, '');

    if (statusFilter === 'Overdue') {
      return (
        normalizedStatus === 'OVERDUE' ||
        normalizedStatus === 'OVERDUEPENDING'
      );
    }

    if (statusFilter === 'Due Soon') {
      return (
        normalizedStatus === 'DUESOON' ||
        normalizedStatus === 'DUESOONPENDING' ||
        normalizedStatus === 'UPCOMING'
      );
    }

    return true;
  });
};
